

import getters from './getters';
import mutations from './mutations';


const state = {
  asOfDate: '',
  mega: '',
  large: '',
  medium: '',
  mediam: '',
  small: '',
  micro: ''
};

export default {
  getters,
  mutations,
  state
};
